export default __webpack_public_path__ + "media/images/favicon-93508a4fc15f2a6136da01b92cf6dcbc.ico";